import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/exame-laboratorial`

    const headers = { responseType: "arraybuffer" }

    return {
       relatorioExameBloqueado(queryParms) {

            return repository.get(`${baseUrl}/relatorio-exame-bloqueado?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioCotaConsumo(queryParms) {

            return repository.get(`${baseUrl}/export-cota-consumo?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioExameSolicitadoStatus(queryParms) {

            return repository.get(`${baseUrl}/relatorio-exame-solicitado-status?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioExameProducao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-exame-producao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioFinanceiroPaciente(queryParms) {

            return repository.get(`${baseUrl}/relatorio-financeiro-paciente?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioColetaRealizada(queryParms) {

            return repository.get(`${baseUrl}/relatorio-coleta-realizada?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioFinanceiroExame(queryParms) {

            return repository.get(`${baseUrl}/relatorio-financeiro-exame?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioQuantitativoProducao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-quantitativo-producao?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioPacienteAtendido(queryParms) {
            return repository.get(`${baseUrl}/relatorio-paciente-atendido?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioQuantitativoExameSolicitado(queryParms) {

            return repository.get(`${baseUrl}/relatorio-quantitativo-exame-solicitado?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioHistoricoPaciente(queryParms) {

            return repository.get(`${baseUrl}/relatorio-historico-paciente?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioExameLaboratorioApoio(queryParms) {

            return repository.get(`${baseUrl}/relatorio-exame-laboratorio-apoio?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}